import { render } from "./NavigationCreatePage.vue?vue&type=template&id=5c2146c0"
import script from "./NavigationCreatePage.vue?vue&type=script&lang=js"
export * from "./NavigationCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__